<template>
	<div class="collection-page">
		<nio-header-nav
			ref="headerNav"
			:height.sync="headerHeight"
			:is-white="true"
			position="fixed"
			:scroll-listener="true"
			@back="handleClose"
		>
			<template v-slot:center="config">
				<span class="dynamic-title" :class="{ show: config.offset > 40 + 20 }">我的收藏</span>
			</template>
		</nio-header-nav>

		<p class="page-title" :style="{ paddingTop: headerHeight + 20 + 'px' }">
			我的收藏
		</p>

		<div class="page-content">
			<div
				v-for="(item, index) in filterCars"
				:key="item.commodity_code"
				class="car-item-container"
				@click="enterDetail(item)"
				v-sd-exp:MallMktExpo="{
					page: '我的收藏',
					store: 'PT004',
					mkt_in_type: '商品',
					mkt_in_id: item.commodity_code,
					mkt_in_title: getCarFullTitle(item),
					mkt_in_rank: index + 1,
					mkt_in_number: 1
				}"
				v-sd-clk:MallMktClick="{
					page: '我的收藏',
					store: 'PT004',
					mkt_in_type: '商品',
					mkt_in_id: item.commodity_code,
					mkt_in_title: getCarFullTitle(item),
					mkt_in_rank: index + 1,
					mkt_in_number: 1
				}"
			>
				<van-swipe-cell :right-width="94" :disabled="item.inScroll">
					<div style="padding: 0 20px">
						<car-item
							:car="item"
							:show-collect="false"
							theme="horizontal"
							@scrollStart="handleScrollStart(item)"
							@scrollEnd="handleScrollEnd(item)"
						/>
					</div>
					<template #right>
						<div class="remove-btn" @click="onCancel(item)">
							<span>取消收藏</span>
						</div>
					</template>
				</van-swipe-cell>
			</div>
		</div>

		<div v-if="!carItems.length && !loading" class="empty-tips">
			<img :src="EmptyImg" style="width: 100px" />
			<p class="tips-text">暂无收藏车辆</p>
		</div>
	</div>
</template>

<script>
import { NioToast } from '@nio-fe/nio-app-ui'
import CarItem from '@/components/CarItem'
import { cancelCollectCar, queryCollectedList } from '@/model'
import util from '@/util/util'
import EmptyImg from '@/assets/images/empty-seller.png'
import nativeHybrid from '@/util/nativeHybrid'
import { mapMutations, mapState } from 'vuex'
import link from '@/util/link'
import { allCarDisabledStatus, getCarFullTitle } from '@/views1/IndexPage/filterOptions'
import sensors from '@/util/dataTrack'

export default {
	name: 'Index',
	components: { CarItem },
	data() {
		return {
			EmptyImg,
			headerHeight: 0,
			carItems: [],
			scrollTopNum: 0,
			pagination: {
				page: 0,
				hasMore: true
			},
			loading: true
		}
	},
	created() {
		this.queryList()
	},
	mounted() {
		this.listenLoadMore(() => this.loadMore())
	},
	computed: {
		...mapState('homeState', {
			cancelCollectRecord: state => state.cancelCollectRecord
		}),

		filterCars() {
			const records = this.carItems.filter(item => {
				return this.cancelCollectRecord.indexOf(item.commodity_code) < 0
			})
			return records.map(r => ({ inScroll: false, ...r }))
		}
	},
	methods: {
		...mapMutations('homeState', ['cancelCollect']),

		getCarFullTitle,
		enterDetail(carItem) {
			if (allCarDisabledStatus.some(one => one.value === carItem.status)) {
				const statusName = allCarDisabledStatus.find(one => one.value === carItem.status).label
				this.$toast('该商品' + statusName + '，无法进入详情')

				return
			}
			const { commodity_code } = carItem

			link.goToRoute('/detail', {
				sku_code: commodity_code,
				is_favorite: true
			})
		},
		listenLoadMore(fn) {
			let timer = null
			const onScroll = () => {
				if (timer !== null) {
					clearTimeout(timer)
				}
				timer = setTimeout(() => {
					if (window.scrollY + window.innerHeight > document.body.scrollHeight - 10) {
						fn()
					}
				}, 50)
			}

			window.addEventListener('scroll', onScroll)
		},
		loadMore() {
			if (!this.pagination.hasMore || this.loading) {
				return
			}

			this.queryList()
		},

		async queryList() {
			this.loading = true

			try {
				const { data } = await queryCollectedList.post({
					offset: this.pagination.page * 10,
					limit: 10
				})

				if (!data || data.result_code !== 'success') {
					throw new Error()
				}

				if (this.pagination.page === 0) {
					this.carItems = data.data
				} else {
					const newList = data.data
					newList.forEach(item => {
						if (!this.carItems.some(one => one.commodity_code === item.commodity_code)) {
							this.carItems.push(item)
						}
					})
				}

				if (data.data.length < 10) {
					this.pagination.hasMore = false
				} else {
					this.pagination.hasMore = true
				}
				this.pagination.page += 1
			} catch (e) {
			} finally {
				this.loading = false
			}
		},
		async onCancel(item) {
			const { commodity_code } = item

			await cancelCollectCar.post({ commodity_code })

			this.$toast('已取消收藏')

			this.carItems = this.carItems.filter(one => one.commodity_code !== commodity_code)

			this.cancelCollect(commodity_code)

			sensors.track('MallMktClick', {
				page: '我的收藏',
				button_name: '取消收藏',
				track_sign: 'aMall.b42.d44.click.MallMktClick'
			})
		},
		handleClose() {
			sensors.track('MallMktClick', {
				page: '我的收藏',
				store: 'PT004',
				button_name: '返回',
				track_sign: 'aMall.b42.d43.click.MallMktClick'
			})
			nativeHybrid.closeSyn()
		},
		handleScrollStart(item) {
			this.carItems.forEach(one => {
				if (one.commodity_code === item.commodity_code) {
					one.inScroll = true
				}
			})
			this.carItems = this.carItems.concat()
		},
		handleScrollEnd(item) {
			this.carItems.forEach(one => {
				if (one.commodity_code === item.commodity_code) {
					one.inScroll = false
				}
			})
			this.carItems = this.carItems.concat()
		}
	},
	watch: {
		filterCars: {
			deep: true,
			handler() {}
		}
	}
}
</script>

<style lang="scss" scoped>
@import '~@nio-fe/nio-app-ui/es/style';

.page-title {
	@include headline_1(1.2, 400, false);
	color: $text_primary;

	padding-left: 20px;
}

.page-content {
	padding-bottom: 40px;
	.car-item-container {
		margin-top: 22px;

		&:first-child {
			margin-top: 45px;
		}

		::v-deep {
			.remove-btn {
				@include subtitle_3();
				width: 94px;
				height: 100%;
				background-color: $support_error_4;
				color: #ffffff;
				display: flex;
				align-items: center;
				justify-content: center;
			}
		}
	}
}

.empty-tips {
	width: 100%;
	margin-top: 163px;
	display: flex;
	flex-direction: column;
	align-items: center;

	.tips-text {
		margin-top: 32px;
		@include body_1();
		color: $text_tertiary;
	}
}
::v-deep {
	.dynamic-title {
		opacity: 0;
		transition: opacity 0.2s linear;
	}
	.dynamic-title.show {
		opacity: 1;
	}
}
</style>
